type ArrayItem<Value> = Value extends readonly (infer Item)[] ? Item : Value

export function toArray<Value>(value: Value): ArrayItem<Exclude<Value, undefined>>[] {
  if (value === undefined) {
    return []
  }

  return (Array.isArray(value) ? [...value] : [value]) as ArrayItem<Exclude<Value, undefined>>[]
}

export function fromArray<Value>(value: Value): ArrayItem<Exclude<Value, undefined>> | undefined {
  return (Array.isArray(value) ? value[0] : value) as ArrayItem<Exclude<Value, undefined>> | undefined
}

export function isArraysEqual<T>(array1: T[], array2: T[]) {
  if (array1.length !== array2.length) {
    return false
  }

  const array1Sorted = array1.slice().sort()
  const array2Sorted = array2.slice().sort()

  return array1Sorted.every((value, index) => value === array2Sorted[index])
}
